module.exports = __webpack_public_path__ + "static/img/img_4.34a5610.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_4.png
// module id = huNo
// module chunks = 0